module.exports = {
  apiKey: 'AIzaSyCvP80wT2g1cOsEIYI4HWrq_Q1VnVERtZM',
  authDomain: 'platypus-a8d57.firebaseapp.com',
  databaseURL: 'https://platypus-a8d57.firebaseio.com',
  projectId: 'platypus-a8d57',
  storageBucket: 'platypus-a8d57.appspot.com',
  messagingSenderId: '792017332619',
  appId: '#',
};
